import { useLang } from '@/i18n';
import styles from './index.module.scss';
import EfImg from '@elem/ui/ef-img';
import EfSpec from '@elem/ui/ef-spec';
import { useEffect, useState } from 'react';
import Size from './Size';
import Weight from './Weight';

export default function TheComp() {
    const { t } = useLang('theProduct');
    const [enter, setEnter] = useState<boolean>(false);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const sceneEnter = AniContainer.create({
                triggerElement: `.${styles.comp} .wrapper2`,
                triggerHook: 1,
                offset: 0,
                duration: '100%',
                onEnter: () => setEnter(true),
                onLeave: () => setEnter(false),
            });

            return () => sceneEnter.destroy();
        }
    }, []);

    return (
        <div className={styles.comp}>
            <EfSpec />
            <p className="label">{t('D_label')}</p>
            <p className="title">{t('D_title')}</p>
            <p className="desc">{t('D_desc')}</p>
            <div className="box">
                <div className="inner">
                    <div className="wrapper1">
                        <div className="inner-title">{t('D_inner_title1')}</div>
                        <ul className={`items ${enter ? 'enter' : 'leave'}`}>
                            <li className="item item1">
                                <p className="bar"></p>
                                <div className="bar-text">
                                    <span className="item-name">{t('D_item1_name')}</span>
                                    <span className="item-time">{t('D_item1_time')}</span>
                                </div>
                            </li>
                            <li className="item item2">
                                <p className="bar"></p>
                                <div className="bar-text">
                                    <span className="item-name">{t('D_item2_name')}</span>
                                    <span className="item-time">{t('D_item2_time')}</span>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div className="wrapper2">
                        <div className="inner-title">{t('D_inner_title2')}</div>
                        <ul className="lists">
                            <li className="list">
                                <div className="list-icon">
                                    <Size />
                                </div>
                                <div className="list-info">
                                    <p className="list-title">{t('D_list1_title')}</p>
                                    <p className="list-desc">{t('D_list1_desc')}</p>
                                </div>
                            </li>
                            <li className="list">
                                <div className="list-icon">
                                    <Weight />
                                </div>
                                <div className="list-info">
                                    <p className="list-title">{t('D_list2_title')}</p>
                                    <p className="list-desc">{t('D_list2_desc')}</p>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="img">
                    <EfImg
                        pc="https://websiteoss.ecoflow.com/upload/image/1736495529300/4.jpg"
                        h5="https://websiteoss.ecoflow.com/upload/image/1736495529141/4_M.jpg"
                    />
                </div>
            </div>
        </div>
    );
}
